module.exports = __webpack_public_path__ + "img/check.c133823d.svg";